var _excluded = ["property", "sponsorship"];
var _templateObject;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Element } from 'react-scroll';
import ListingEnquiryForm from './listing-enquiry-form';
import { agencyToProps, agentType, agentToProps } from './utils/graphql-mappings';
import sponsorshipType from './props/sponsorship-type';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment ListingEnquiryForms on Property {\n    listing {\n      type\n      id\n      auctions: events(type: AUCTION) {\n        hasOnlineAuction\n      }\n    }\n    address {\n      formattedFull\n      division {\n        id\n      }\n      district {\n        id\n      }\n      region {\n        id\n      }\n      postcode\n    }\n    agencies {\n      agencyId\n      name\n      profileUrl\n      logoBackgroundColour\n      flags\n      type\n      phone\n      images {\n        logo\n      }\n      agents {\n        agentId\n        profilePhoto\n        name\n        phone\n        profileUrl\n      }\n    }\n  }\n"])));
var graphQLToProps = _ref => {
  var _listing$auctions, _listing$auctions$fil;
  var listing = _ref.listing,
    address = _ref.address,
    agencies = _ref.agencies;
  return {
    listingType: listing.type,
    listingAddress: address.formattedFull,
    hasOnlineAuction: ((_listing$auctions = listing.auctions) === null || _listing$auctions === void 0 ? void 0 : (_listing$auctions$fil = _listing$auctions.filter(event => event.hasOnlineAuction)) === null || _listing$auctions$fil === void 0 ? void 0 : _listing$auctions$fil.length) > 0,
    agencies: agencies.map(agency => _objectSpread(_objectSpread({}, agencyToProps(agency)), {}, {
      type: agentType(agency),
      agents: agency.agents.map(agent => agentToProps(_objectSpread(_objectSpread({}, agent), {}, {
        agency
      })))
    }))
  };
};
var hasValue = value => testValue => "".concat(value) === "".concat(testValue);
var validateSponsorship = _ref2 => {
  var _localities$regions, _localities$districts, _localities$divisions, _localities$postcodes;
  var property = _ref2.property,
    sponsorship = _ref2.sponsorship;
  var _ref3 = (sponsorship === null || sponsorship === void 0 ? void 0 : sponsorship.sponsorship) || {},
    localities = _ref3.localities;
  if (!localities) {
    return null;
  }
  var _ref4 = property.address || {},
    region = _ref4.region,
    district = _ref4.district,
    division = _ref4.division,
    postcode = _ref4.postcode;
  if ((_localities$regions = localities.regions) !== null && _localities$regions !== void 0 && _localities$regions.some(hasValue(region === null || region === void 0 ? void 0 : region.id)) || (_localities$districts = localities.districts) !== null && _localities$districts !== void 0 && _localities$districts.some(hasValue(district === null || district === void 0 ? void 0 : district.id)) || (_localities$divisions = localities.divisions) !== null && _localities$divisions !== void 0 && _localities$divisions.some(hasValue(division === null || division === void 0 ? void 0 : division.id)) || (_localities$postcodes = localities.postcodes) !== null && _localities$postcodes !== void 0 && _localities$postcodes.some(hasValue(postcode))) {
    return sponsorship;
  }
  return null;
};
var ListingEnquiryFormGraphQL = _ref5 => {
  var property = _ref5.property,
    sponsorship = _ref5.sponsorship,
    props = _objectWithoutProperties(_ref5, _excluded);
  return ___EmotionJSX("div", null, ___EmotionJSX(Element, {
    id: "ListingEnquiryForm-Agency-0"
  }), ___EmotionJSX(ListingEnquiryForm, _extends({
    sponsorship: validateSponsorship({
      property,
      sponsorship
    })
  }, props, graphQLToProps(property))));
};
ListingEnquiryFormGraphQL.propTypes = {
  property: PropTypes.shape({
    listing: PropTypes.shape({
      type: PropTypes.string,
      id: PropTypes.string
    }),
    address: PropTypes.shape({
      formattedFull: PropTypes.string,
      region: PropTypes.shape({
        id: PropTypes.string
      }),
      district: PropTypes.shape({
        id: PropTypes.string
      }),
      division: PropTypes.shape({
        id: PropTypes.string
      }),
      postcode: PropTypes.string
    }),
    agents: PropTypes.arrayOf(PropTypes.shape({
      agentId: PropTypes.string,
      name: PropTypes.string,
      profilePhoto: PropTypes.string,
      agency: PropTypes.shape({
        agencyId: PropTypes.string,
        name: PropTypes.string,
        profileUrl: PropTypes.string,
        logoBackgroundColour: PropTypes.string,
        flags: PropTypes.arrayOf(PropTypes.string),
        images: PropTypes.shape({
          logo: PropTypes.string
        })
      })
    }))
  }).isRequired,
  sponsorship: PropTypes.shape(sponsorshipType)
};
ListingEnquiryFormGraphQL.defaultProps = {
  sponsorship: null
};
ListingEnquiryFormGraphQL.fragment = fragment;
export default ListingEnquiryFormGraphQL;